export default __webpack_public_path__ + "assets/images/mock-ad-image-vehicle_2wvwk.jpg";